<style scoped>
  .search >>> .ivu-input {width: 348px;height: 36px;border-radius: 18px;font-size: 14px;color: #bbbbbb;padding: 0 30px 0 22px;}
  .approval >>> .ivu-btn {width: 130px;border-radius: 36px;}
  .approval-list-tab {text-align: center;color: #333333;font-size: 14px;font-weight: bold;line-height: 62px; /*border-bottom: 1px solid #d7dde4;*/}
  .approval-list {text-align: center;color: #464c5b;font-size: 14px;height:55px;/*border-bottom: 1px solid #d7dde4;*/}
  .notice-background{background: url("/img/sys/bg14.png");height: 140px;}
  .jurisdiction{font-size: 14px;color: #464c5b;line-height: 60px;height: 60px;font-weight: bold;text-align: center;border-bottom: 1px solid #d7dde4;}
  .jurisdiction-list{font-size: 14px;color: #464c5b;line-height: 76px;height: 76px;text-align: center;border-bottom: 1px solid #d7dde4;}
  .tips-middle{display: inline-block;vertical-align:middle;line-height: 1em}
</style>
<template>
  <div>
    <Modal v-model="filePanel.state" title="文件夹名称" @on-ok="saveFolder" width="350">
      <Input v-model="filePanel.name" placeholder="请输入文件夹名称" style="width: 300px" />
    </Modal>
    <Row>
      <Col span="24" class="notice-background"></Col>
    </Row>
    <div style="background-color:#fff;padding:0 40px;">
      <Row style="background-color:white;height:65px;position: relative;">
        <Col span="20" style="position:absolute;top: 50%;left: 0;transform: translate(0, -50%);">
          <div style="position:relative;">
            <Input class="search" v-model="search.text" placeholder="搜索目录/文件名称"></Input>
            <div
                @click="getList()"
                style="background-color:#00a2e9;width: 28px;height: 28px;border-radius: 14px;position: absolute;top: 4px;text-align: center;left: 310px;cursor:pointer;">
              <img style="margin-top: 6px;" src="/img/project/search-icon.png"/>
            </div>
          </div>
        </Col>
        <Col span="3" v-if="$store.state.userInfo.groupName=='超级管理员'" class="approval" style="position: absolute;top: 50%;right: 20px;transform: translate(0, -50%);">
          <Button type="primary" style="width:80px" @click="upload.panel=true,upload.od='',upload.src=''">上传文件</Button>
        </Col>
      </Row>
      <!---->
      <Tabs value="customer">
        <TabPane label="文件目录" name="customer">
          <Row class="approval-list-tab">
            <Col span="6" style="text-align: left;padding-left:15px;">名称</Col>
            <Col span="2">类型</Col>
            <Col span="5">操作</Col>
          </Row>
          <Row v-if="parseInt(fileInfo.StorageId)!=0">
            <Col span="24" style="margin:5px;cursor:pointer;font-size:14px;color: blue"><div @click="backFile">..返回上一级</div></Col>
          </Row>
          <Row class="approval-list" v-for="(item,index) in filesList" :style="index%2==0?'background-color:#f8f8f9':''">
            <Col span="6" style="text-align: left;padding-left:15px;height: 100%;line-height:55px">
              <a :href="item.FileType==0?getServerURL('default',false)+'/'+item.StoragePath:'javascript:;'" :target="item.FileType==0?'_blank':''">
                <span @click="selectFile(item)" style="cursor:pointer;display:inline-block;vertical-align: middle;line-height: 1em">{{item.StorageTitle}}</span>
              </a>
            </Col>
            <Col span="2" style="height: 100%;line-height:55px"><span style="display:inline-block;line-height:1em;vertical-align: middle;">{{item.FileType==0?'文件':'文件夹'}}</span></Col>
            <Col span="5" style="text-align: center;line-height:55px">
              <Button
                  v-if="$store.state.userInfo.groupName=='超级管理员'"
                  type="primary"
                  style="border-radius: 18px;"
                  @click="upload.name = item.StorageTitle,
                  upload.id = item.StorageId,
                  upload.panel=true">
                重命名
              </Button>
              <Button
                  v-if="$store.state.userInfo.groupName=='超级管理员'"
                  type="error"
                  style="border-radius: 18px;margin-left:10px"
                  @click="deletefile(item.StorageId)"
              >
                删除
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span="24" style="margin:5px;cursor:pointer;font-size:18px;padding:5px;border:#eee dashed 2px;border-radius:5px;"  v-if="$store.state.userInfo.groupName=='超级管理员'"><div @click="filePanel.state = true">+新建文件夹</div></Col>
          </Row>
          <div style="padding: 20px;"></div>
        </TabPane>
      </Tabs>
      <!---->
      <Modal
          v-model="upload.panel"
          :title="upload.id?'重命名':'上传文件'"
          width="700px"
          @on-ok="uploadFile"
          ok-text="保存"
      >
        <Row type="flex" align="middle">
          <Col span="4" style="text-align: right">文件名称：</Col>
          <Col span="7"><Input v-model="upload.name"></Input></Col>
          <template v-if="!upload.id">
          <Col span="4" style="text-align: right">选择文件：</Col>
          <Col span="7">
            <Upload
                :show-upload-list="false"
                :on-success="uploadSuccess"
                style="display: inline-block;vertical-align:middle"
                :headers="{GroupId:groupId,Con:'S',Fun:'UploadStorage',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
                :data="{MenuId:menuId,UserId:userId}"
                :action="getServerURL('default',true)">
              <Button
                  icon="ios-cloud-upload-outline"
                  :type="upload.name?'success':'primary'"
              >
                {{upload.showName||'请选择文件'}}
              </Button>
            </Upload>
          </Col>
          </template>
        </Row>
      </Modal>
      <div style="padding: 20px;"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "networkDisk",
    data:function(){
      return{
        list:"",
        fileInfo:{
          Fid:'0',
          FileType:'',
          StorageId:'0',
          StoragePath: '',
          StorageSize:"0",
          StorageTitle:"",
        },
        upload:{
          panel:false,
          name:'',
          src:'',
          showName:'',
        },
        filePanel:{
          name:'',
          id:'',
          fid:'0',
          state:false,
        },
        search:{
          pageSize: 15,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
          text:'',//搜索文字
        },
        filesList:[],
      }
    },
    methods: {
      backFile:function(){
        this.fileInfo.StorageId = this.fileInfo.Fid
        this.getFileList()
      },
      selectFile:function(item){
        if(item.FileType==0){
          return
        }
        this.fileInfo = item
        this.getFileList()
      },
      saveFolder:function(){
        var _this = this
        _this.send({
          headers:'S/NewStorage',
          data:{
            'FliesPath':'',
            'FliesTitle':_this.filePanel.name,
            'FileType':1,
            'Fid':_this.fileInfo.Fid,
          },
          success:function (res) {
            _this.getFileList()
            _this.$Notice.success({
              title:'系统提示',
              desc:'文件已新建！'
            })
          }
        })
      },
      uploadFile:function(){
        var _this = this
        _this.send({
          headers:'S/NewStorage',
          data:{
            'FliesPath':_this.upload.src,
            'FliesTitle':_this.upload.name,
            'Fid':_this.fileInfo.StorageId,
          },
          success:function (res) {
            _this.getFileList()
            _this.$Notice.success({
              title:'系统提示',
              desc:'文件已保存！'
            })
          }
        })
      },
      uploadSuccess:function (response,file,fileList) {
        if(!this.upload.name){
          this.upload.name = response.Data.name
        }
        this.upload.showName = response.Data.name
        this.upload.src = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },
      //获取文件列表
      getFileList:function () {
        var _this = this
        _this.send({
          headers:'S/StorageList',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
            StorageId:_this.fileInfo.StorageId,
          },
          success:function (res) {
            _this.filesList = res
          }
        })
      },
      getLitigationStatusList:function(){
        var _this = this
        _this.send({
          headers:'R/LitigationStatus',
          success:function (res) {
            _this.roleMap = []
            for(var index in res){
              _this.roleMap.push({
                name:res[index].LitigationStatusName,
                id:res[index].LitigationStatusId
              })
            }
            _this.getList()
          }
        })
      },
      changeState:function(item){
        var _this = this
        _this.send({
          headers:'R/EditCustomer ',
          data:{
            LitigantId:item.id,
            LitigantName:item.name,
            LitigantMobile:item.mobile,
            LitigantIdCard:item.IDCardCode,
            LitigationStatusId:item.role,
            LitigantAble:item.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      saveCustomer:function(){
        var _this = this
        _this.send({
          headers:'R/EditCustomer ',
          data:{
            LitigantId:_this.edit.id,
            LitigantName:_this.edit.name,
            LitigantMobile:_this.edit.mobile,
            LitigantIdCard:_this.edit.IDCardCode,
            LitigationStatusId:_this.edit.role,
            LitigantAble:_this.edit.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      deletefile:function(id){
        var _this = this
        _this.send({
          headers:'S/DelStorage ',
          confirm:true,
          data:{
            StorageId:id,
          },
          success:function (res) {
            _this.getFileList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'文件删除成功！'
            })
          }
        })
      },
      createCustomer:function(){
        var _this = this
        _this.send({
          headers:'R/AddCustomer',
          data:{
            LitigantName:_this.edit.name,
            LitigantMobile:_this.edit.mobile,
            LitigantIdCard:_this.edit.IDCardCode,
            LitigationStatusId:_this.edit.role,
            LitigantAble:_this.edit.state,
          },
          success:function (res) {
            _this.getList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'客户信息保存成功！'
            })
          }
        })
      },
      getList:function () {
        var _this = this
        _this.send({
          headers:'R/ShowCustomer',
          data:{
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            key : _this.search.text,
          },
          success:function (res) {
            var i = 0
            _this.list = []
            for(var index in res.List){
              _this.list.push({
                id:res.List[index].LitigantId,
                name:res.List[index].LitigantName,
                contactName:res.List[index].CaseLinkman,
                contactMobile:res.List[index].CaseLinkmanTel,
                IDCardCode:res.List[index].LitigantIdCard,
                state:typeof res.List[index].LitigantAble=='number'?res.List[index].LitigantAble.toString():'',
                role:res.List[index].LitigationStatusId,
                roleName:res.List[index].LitigationStatusName,
                identityName:res.List[index].LitigantTypeTitle,
                projectName:res.List[index].CaseTitle,
              })
              i++
            }
            _this.search.total = res.count
          }
        })
      }
    },
    mounted:function(){
      this.getFileList()
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>

